import { Component } from '@angular/core';

import { ManageEsaBm, ManageEsaVm } from '../../models';
import { EventBaseComponent } from '../event-base/event-base.component';
import { EventsService } from '../events.service';

@Component({
    selector: 'event-manage-esa',
    templateUrl: './event-manage-esa.component.html'
})
export class EventManageEsaComponent extends EventBaseComponent {
    public custom = { error: '' };
    public esa: ManageEsaBm = new ManageEsaBm();
    public warrantyExpDate: string;
    public warrantyStatus: string;
    public esaEndDate: string;
    public esaStatus: string;
    public sn: string;

    public statuses = [
        { value: '', label: '' },
        { value: 'Invoice Sent', label: 'ESA Invoice Sent' },
        { value: 'Invoice Paid', label: 'ESA Invoice Paid' },
        { value: 'Active', label: 'ESA Active' },
        { value: 'Expired', label: 'ESA Expired' }
    ];

    constructor(public eventsService: EventsService) {
        super(eventsService);
    }

    ngOnInit(): void {
        this.model.wait = true;

        this.eventsService
            .getManageEsaVm(this.model.sn)
            .then(res => {
                if(!res.sn === undefined)
                {
                    if (!res.sn.length) {
                        this.custom.error = 'There has been an error retrieving information from the server. Please try again.';
                    }
                }
                
                this.esa.esaEndDate = res.esaEndDate;
                this.esa.esaStatus = res.esaStatus;
                this.esa.warrantyExpDate = res.warrantyExpDate;
                this.esa.warrantyStatus = res.warrantyStatus;
                this.warrantyExpDate = res.warrantyExpDate;
                this.warrantyStatus = res.warrantyStatus;
                this.esaEndDate = res.esaEndDate;
                this.esaStatus = res.esaStatus;
                this.esa.sn = this.model.sn;
                this.sn = this.model.sn;

                const str = this.esa.esaEndDate.toString()
                const [month, day, year] = str.split('/');
                const date = `${year}-${month}-${day}`;
                this.esa.esaEndDate = date
                
                this.model.wait = false;
            })
            .catch(error => {
                this.model.wait = false;
                this.model.error = error;
            });
    }

    public manageEsa(): void {
        this.model.wait = true;

        const data = new ManageEsaVm();
        data.sn = this.model.sn === undefined || this.model.sn === null ? this.esa.sn : this.model.sn;
        data.esaEndDate = this.esa.esaEndDate;
        data.esaStatus = this.esa.esaStatus;
        data.comment = this.model.comment;

        this.eventsService
            .manageEsa(data)
            .then(() => {
                this.backToEvents();
            })
            .catch(error => {
                this.model.wait = false;
                this.model.error = error;
            });
    }

    public onEsaStatusChange(): void {
        if (this.esa.esaStatus === 'Active') {
            if (this.warrantyExpDate === undefined || this.warrantyExpDate === null || this.warrantyExpDate === '') {
                this.custom.error = 'Warranty Expiration Date is required when ESA Status is set to Active. Update the Warranty Expiration Date and try again.';
                
                this.esa.esaEndDate = '';
                this.esaEndDate = '';
                return;
            }
            const str = this.esa.warrantyExpDate.toString();
            const [month, day, year] = str.split('/');
            const wedate = `${year}-${month}-${day}`;
            const addYear = new Date(wedate);

            //console.log('wedate: ' + wedate);

            // Leap year adjustment 
            const newYear = addYear.getFullYear();
            const newMonth = addYear.getMonth() + 1;
            const newDay = addYear.getDate() + 1; 
            
            addYear.setFullYear(addYear.getFullYear() + 1);

            //console.log('addYear - before adjustment: ' + addYear.getFullYear() + "-" + (addYear.getMonth() + 1) + "-" + addYear.getDate());     

            if (((newYear % 4 === 0 && newYear % 100 !== 0) || 
                (newYear % 400 === 0)) && (newMonth === 2 && newDay === 29)) {
                addYear.setDate(addYear.getDate());
            } else {
                addYear.setDate(addYear.getDate() + 1);
            }

            //console.log('addYear - after  adjustment: ' + addYear.getFullYear() + "-" + (addYear.getMonth() + 1) + "-" + addYear.getDate());  

            const yearStr = addYear.getFullYear();
            const monthStr = addYear.getMonth() + 1;
            const dayStr = addYear.getDate();
            const monthStr2 = monthStr < 10 ? '0' + monthStr : monthStr;
            const dayStr2 = dayStr < 10 ? '0' + dayStr : dayStr;

            const dayStrComplete = yearStr + '-' + monthStr2 + '-' + dayStr2;

            //console.log('dayStrComplete: ' + dayStrComplete);

            this.esa.esaEndDate = dayStrComplete;
            this.esaEndDate = dayStrComplete;

        } else {
            if (this.esa.esaStatus !== 'Expired') {
                this.esa.esaEndDate = '';
                this.esaEndDate = '';
            }
        }
    }
}